
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'

export default {
name: 'index',
components: {
Tabbar,
TabbarItem,
XImg
},
data () {
return {
left: false,
right: false,
footMenu: []
}
},
beforeMount () {
this.$vue = this

this.initFootMenu()

this.$wechat.miniProgram.getEnv(function (res) {
if (res.miniprogram) {
console.log(res.miniprogram)

let link = document.createElement('link')
link.setAttribute('rel', 'stylesheet')
link.setAttribute('type', 'text/css')
link.setAttribute('href', '../../../static/css/mini.css')
window.document.head.appendChild(link)
}
})
},
methods: {
async initMenu () {
try {
let response = await this.$http.post(this.$vue.getData('PERSONINFO_URL'))
if (response.data.data.role_id === '1010') {
this.initFootMenuTwo()
} else {
this.initFootMenu()
}
} catch (error) {
this.initFootMenu()
}
},
linkTo (name) {
this.$router.push({name: name})
},

initFootMenu () {
this.footMenu = [
{
routerName: 'HomePage',
class: 'icon-home-1',
name: '首页'
}, {
routerName: 'DzdCaseList',
class: 'icon-auscultation',
name: '未报告'
}, {
routerName: 'YzdCaseList',
class: 'icon-report-search',
name: '已报告'
}
]
},

initFootMenuTwo () {
this.footMenu = [
{
routerName: 'HomePage',
class: 'icon-home-1',
name: '首页'
}, {
routerName: 'DzdCaseList',
class: 'icon-auscultation',
name: '未报告'
}, {
routerName: 'YzdCaseList',
class: 'icon-report-search',
name: '已报告'
}, {
routerName: 'MedicalUnionList',
class: 'icon-auscultation',
name: '医联体'
}
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/foot.vue